/* eslint-disable react/react-in-jsx-scope */
import axios from "axios"
import { motion } from "framer-motion"
import { useEffect, useState } from "react"
import { Card, CardBody, Col, Row, Spinner } from "reactstrap"
import "./CardProcesso.css"
import formatNumber from "./formatNumber"

const CardsPublications = () => {
  const [publicationsData, setPublicationsData] = useState({
    totalPublicacoes: {
      total: 0,
      ontem: 0,
      noMes: 0
    },
    priorizadas: {
      total: 0,
      ontem: 0,
      noMes: 0
    },
    novasPublicacoes: {
      total: 0,
      ontem: 0,
      noMes: 0
    }
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchPublicationsStats = async () => {
      try {
        setLoading(true)
        const response = await axios.get(`${process.env.REACT_APP_API_EXT_LEADS}/api/processos/publications-stats`)
        
        setPublicationsData(response.data)
        setError(null)
      } catch (err) {
        console.error('Erro ao buscar estatísticas de publicações:', err)
        setError(err.response?.data?.message || err.message || 'Erro ao carregar dados')
      } finally {
        setLoading(false)
      }
    }

    fetchPublicationsStats()
  }, [])

  const publicationStats = [
    {
      title: "Total de Publicações",
      key: "totalPublicacoes",
      icon: "bx bx-book",
      gradient: "linear-gradient(135deg, #6B8DE3 0%, #4318FF 100%)",
    },
    {
      title: "Priorizadas",
      key: "priorizadas",
      icon: "bx bx-flag",
      gradient: "linear-gradient(135deg, #53B947 0%, #169F85 100%)",
    },
    {
      title: "Novas Publicações",
      key: "novasPublicacoes",
      icon: "bx bx-plus-circle",
      gradient: "linear-gradient(135deg, #FFAA2B 0%, #FB9678 100%)",
    },
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const cardVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  }

  const numberVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  }

  const getClassificationValue = (key) => {
    return publicationsData[key] || { total: 0, ontem: 0, noMes: 0 }
  }

  const renderPublicationValue = (key, metric) =>
    loading ? (
      <Spinner size="sm" color="light" />
    ) : error ? (
      <span className="text-white-50">Erro</span>
    ) : (
      formatNumber(getClassificationValue(key)[metric] || 0)
    )

  return (
    <div className="dashboard-stats">
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <Card className="shadow-lg border-0 rounded-lg">
          <CardBody>
            <Row className="mb-4">
              <Col lg="12">
                <h3 className="text-gradient fw-bold">
                  Estatísticas de Publicações
                </h3>
              </Col>
            </Row>
            <Row>
              {publicationStats.map((stat, index) => (
                <Col lg="4" key={index}>
                  <motion.div variants={cardVariants}>
                    <Card
                      className="stat-card border-0 h-100"
                      style={{
                        background: stat.gradient,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      }}
                    >
                      <CardBody className="p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div className="stat-icon me-3">
                            <span className="rounded-circle bg-white bg-opacity-10 text-white">
                              <i className={`${stat.icon} fs-4`} />
                            </span>
                          </div>
                          <h5 className="text-white mb-0 fw-semibold">
                            {stat.title}
                          </h5>
                        </div>
                        <div className="mt-4">
                          <motion.div
                            variants={numberVariants}
                            className="d-flex align-items-center"
                          >
                            <h2 className="text-white mb-0 me-2 fw-bold">
                              {renderPublicationValue(stat.key, "total")}
                            </h2>
                            <span className="badge bg-white bg-opacity-10 text-white">
                              Total
                            </span>
                          </motion.div>
                          <div className="mt-3 d-flex gap-2">
                            <span className="badge bg-white bg-opacity-10 text-white px-3 py-2">
                              <strong>
                                {renderPublicationValue(stat.key, "ontem")}
                              </strong>{" "}
                              Ontem
                            </span>
                            <span className="badge bg-white bg-opacity-10 text-white px-3 py-2">
                              <strong>
                                {renderPublicationValue(stat.key, "noMes")}
                              </strong>{" "}
                              no Mês
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </motion.div>

      <style>
        {`
    .dashboard-stats .stat-card {
      transition: transform 0.3s ease;
    }
    
    .dashboard-stats .stat-card:hover {
      transform: translateY(-5px);
    }
    
    .dashboard-stats .stat-icon span {
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .text-gradient {
      background: linear-gradient(135deg, #333 0%, #666 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    
    .rounded-lg {
      border-radius: 1rem !important;
    }
  `}
      </style>
    </div>
  )
}

export default CardsPublications